import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { PageContainer, PageHeadline } from '@/components/layout';
import { UserProfileView } from '@/features/user';
import { useUser } from '@/app/providers';
import { useLogout } from '@/hooks/useLogout';
import { LogOut } from '@/design-system/icons';
import { cn } from '@/lib';
import { scrollStyleClass } from '@/utils/scrollClassHelper';

function ProfilePage() {
  const { t } = useTranslation();
  const { user } = useUser();
  const { handleLogout } = useLogout();

  if (!user) {
    return null;
  }

  return (
    <PageContainer>
      {/* Scrollable profile with a sticky headline and sign-out button */}
      <div className={cn("relative space-y-6 min-h-0 flex flex-col overflow-auto", scrollStyleClass)}>
        <div className="flex items-center justify-between sticky top-0 z-10">
          <PageHeadline headlineKey="userProfile.title" />
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 px-3 py-2 text-sm rounded-md hover:bg-surface-darker transition-colors"
          >
            <LogOut className="size-4 text-muted" />
            <span>{t('header.signOut')}</span>
          </button>
        </div>
        <div className='grow'>
          <UserProfileView userId={user.id} showCreateCompany />
        </div>
      </div>
    </PageContainer>
  );
}

export const Route = createFileRoute('/_app/profile')({
  component: ProfilePage,
});
